import { render, staticRenderFns } from "./InternalLink.vue?vue&type=template&id=79d66610&scoped=true"
import script from "./InternalLink.vue?vue&type=script&lang=js"
export * from "./InternalLink.vue?vue&type=script&lang=js"
import style0 from "./InternalLink.vue?vue&type=style&index=0&id=79d66610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d66610",
  null
  
)

export default component.exports